import { Button } from "@/components/ui/button";
import { Sparkles, ShieldCheck, Rocket } from "lucide-react";
import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
const Index = () => (
  <div className="min-h-screen bg-hero">
    <NavBar />
    <main className="mx-auto max-w-6xl px-4 pt-20 pb-24">
      <section className="text-center">
        <span className="inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm text-muted-foreground">
          <Sparkles className="h-4 w-4" /> Launch AI chatbots in minutes
        </span>
        <h1 className="mt-6 text-4xl font-semibold tracking-tight sm:text-6xl">
          Let your creators and fans build their own bots
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
          A modern, embeddable chatbot platform tailored for adult communities like BoyFanz—fast setup, smart safety, and flexible monetization.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Button asChild size="lg">
            <Link to="/create">Create a bot</Link>
          </Button>
          <Button asChild size="lg" variant="outline">
            <Link to="#how">See how it works</Link>
          </Button>
        </div>
      </section>

      <section id="how" className="mt-20 grid gap-6 sm:grid-cols-3">
        <Feature title="Name & Persona" desc="Define tone, bio, and greeting." />
        <Feature title="Knowledge" desc="Add links, docs, and FAQs." />
        <Feature title="Safety & Embed" desc="Set rules, then paste the widget." />
      </section>

      <section className="mt-20 grid items-center gap-6 sm:grid-cols-2">
        <PreviewCard />
        <ul className="space-y-4 text-sm text-muted-foreground">
          <li className="flex items-start gap-3"><ShieldCheck className="mt-0.5 h-4 w-4 text-green-600" />Granular safety controls and NSFW filters.</li>
          <li className="flex items-start gap-3"><Rocket className="mt-0.5 h-4 w-4 text-blue-600" />Drop-in embed for web and deep-links for mobile.</li>
          <li className="flex items-start gap-3"><Sparkles className="mt-0.5 h-4 w-4 text-amber-600" />Clean UX your creators will love.</li>
        </ul>
      </section>
    </main>
  </div>
);

function Feature({ title, desc }: { title: string; desc: string }) {
  return (
    <div className="rounded-xl border bg-card p-6 shadow-sm transition hover:shadow-md">
      <h3 className="text-lg font-medium">{title}</h3>
      <p className="mt-1 text-sm text-muted-foreground">{desc}</p>
    </div>
  );
}

function PreviewCard() {
  return (
    <div className="rounded-xl border p-6 shadow-sm">
      <div className="rounded-lg border bg-muted/20 p-4">
        <div className="mb-3 text-xs text-muted-foreground">Bot preview</div>
        <div className="rounded-lg bg-background p-4">
          <div className="text-sm">Hi, I’m your new creator bot. Ask me anything! ✨</div>
        </div>
      </div>
    </div>
  );
}
export default Index;